import { rm } from 'node:fs/promises';

export function cleanupMergedLogDirForServer(map: Map<string, string>, environmentId: string): void {
  const mergedDir = map.get(environmentId);
  if (!mergedDir) return;
  map.delete(environmentId);
  void rm(mergedDir, { recursive: true, force: true }).catch(() => {});
}
